<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <!-- <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="应收拆分" name="1">
          <div>
            <div class="search-wrap">
              <el-button size="mini" type="primary" @click="search()" style="margin-right: 5px;" icon="el-icon-search">查询</el-button>
              <div style="width: 30px;display: inline-block;"></div>

              <el-button type="primary" size="mini" icon="el-icon-scissors" v-if="multipleSelection.length" @click="splitOrder">选中拆分</el-button>
            </div>

            <div style="margin-bottom: 10px;">
              <el-descriptions :column="2" border size="mini">
                <el-descriptions-item label="收费对象">
                  <el-input size="mini" readonly placeholder="请输入收费对象" v-model="where.h_name_date" clearable></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="计费周期">
                  <el-date-picker
                    size="mini"
                    v-model="where.start_end_time"
                    unlink-panels
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                  <el-radio style="margin-left: 20px" v-model="where.is_between_time" label="1">选择范围</el-radio>
                  <el-radio v-model="where.is_between_time" label="0">选择起始点</el-radio>
                </el-descriptions-item>
                <el-descriptions-item label="收费项目">
                  <el-select v-model="where.xsc_ChargeItemID_id" placeholder="选择收费项" clearable>
                    <el-option
                      v-for="item in house_charge_item_list"
                      :key="item.id"
                      :label="item.chargeItem_name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="收费标准">
                  <el-select v-model="where.charge_id" placeholder="选择收费标准" clearable>
                    <el-option
                      v-for="item in house_charge_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="缴款状态">
                  <el-radio v-model="where.state" label="1">待付款</el-radio>
                  <el-radio v-model="where.state" label="2">已付款</el-radio>
                </el-descriptions-item>
                <el-descriptions-item label="拆分方式">
                  默认无
                </el-descriptions-item>
              </el-descriptions>
            </div>

            <div style="margin-top: 5px;">
              <el-table ref="multipleTable" v-if="pageData" height="47vh" border style="width: 99%" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column prop="h_name_date" label="房产"></el-table-column>
                <el-table-column prop="ChargeItemName" label="收费标准" width="200"></el-table-column>
                <el-table-column label="计费周期" width="180">
                  <template slot-scope="scope">
                    {{scope.row.startDate}} ~ {{scope.row.endDate}}
                  </template>
                </el-table-column>
                <el-table-column prop="xsc_Price" label="单价" width="100"></el-table-column>
                <el-table-column prop="area" label="面积" width="100"></el-table-column>
                <el-table-column prop="chargePay" label="实际应收" width="100"></el-table-column>
                <el-table-column prop="h_name" label="收费对象" width="180"></el-table-column>
                <el-table-column label="状态" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.state===1" size="mini" type="success" effect="dark">未支付</el-tag>
                    <el-tag v-else size="mini" type="danger" effect="dark">已支付</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="pagination-wrap">
              <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="拆分日志" name="2">
          <OrderLog ref="OrderLog" />
        </el-tab-pane>
        <el-tab-pane label="批量拆分" name="3">
          <OrderSplit ref="OrderSplit" />
        </el-tab-pane>
      </el-tabs> -->
      <OrderSplit ref="OrderSplit" />
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="应收拆分" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-descriptions :column="1" border size="mini">
          <el-descriptions-item label="订单条数">
            <span style="color: #ff3d00;">{{form.order_ids.length}}</span> 条
          </el-descriptions-item>
          <el-descriptions-item label="拆分日期">
            <el-date-picker
              size="mini"
              v-model="form.start_end_time"
              unlink-panels
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="拆分后应收是否为0">
            <el-radio v-model="form.clear" label="0">否</el-radio>
            <el-radio v-model="form.clear" label="1">是</el-radio>
          </el-descriptions-item>
          <el-descriptions-item label="进度条">
            <el-progress :percentage="progressObj.percentage" :status="progressObj.status"></el-progress>
          </el-descriptions-item>
          <el-descriptions-item label="执行结果">
            {{progressObj.msg}}
          </el-descriptions-item>
          <el-descriptions-item label="注意">
            应收教拆分要求<br>
            1、必须选择两个新的收标准<br>
            2、两个新的收美标的单价之后必灰和原应收款对应的单价相同<br>
            3、新的收美标注的单价不能为零<br>
            4、应收款必灰先审核才际分<br>
            5、拆分过程可能会进行较长的,青心等待
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" :disabled="form.order_ids.length===0" @click="submitForm()" >开始</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import UploadFilesSysc from "./components/UploadFilesSysc";
import ErpTreeStatus from "../Common/erp-tree-status";
import OrderLog from "./OrderLog";
import OrderSplit from "./OrderSplit";

export default {
  name:"ReceivablesSplitMerge",
  components: {OrderLog, ErpTreeStatus, UploadFilesSysc,OrderSplit},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      activeName:"1",
      where:{
        name:"",
        project_house_id:"",
        start_end_time:"",
        xsc_ChargeItemID_id:"",//费项
        charge_id:"",//费项类型
        state:"1",
        is_between_time:"1"
      },
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
      dialogVisible:false,
      form:{
        start_end_time:"",
        clear:"0",
        order_ids:""
      },
      uploadUrl:"",
      month_value:"",
      multipleSelection:[],
      order_bill_type_list:[],
      house_charge_item_list:[],
      house_charge_list:[],
      progressObj:{
        percentage:0,
        status:"primary",//success
        msg:""
      },
      project_id:"",
    }
  },
  created() {
    this.host_url=__HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getHouseChargeItemList()
    this.$refs.OrderLog.where.use_name="应收拆分";
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "where.xsc_ChargeItemID_id":function (n) {
      this.getHouseChargeList();
    },
    "dow_form.project_house_id":function (n) {
      this.getHouseChargeList();
    },
    order_ids(n){
      n&&(this.form.order_ids=n)
    }
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    },
    order_ids(){
      return this.multipleSelection.map(ret=>{return ret.id;})
    },
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        start_end_time:"",
        clear:"",
        order_ids:""
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      if(this.where.project_house_id == ''){
        // this.$message.error("点击左边树选择房产");
        return false;
      }
      var that=this;
      that.loading=true;
      let where=reObject(this.where);
      where.project_house_id=undefined;
      ERP.getRequest({
        url:"admin/ReceivablesSplitMerge/getList",
        data:{
          project_id:that.project_id,
          where:JSON.stringify(where),
          page: this.pageData.page,
          page_size: this.pageData.pageSize,
          project_house_id:this.where.project_house_id
        }
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
        that.multipleSelection=[]
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    splitOrder() {
      if(this.form.order_ids.length){
        // this.form = this.getFormData({})
        this.progressObj={
          percentage:0,
          status:"primary",//success
          msg:""
        };
        this.dialogVisible = true
      }else {
        this.$message.error("请选择拆分费项");
      }
    },
    splitOrderAll() {
      var that=this;
      let where=reObject(this.where);
      where.project_house_id=undefined;
      that.multipleSelection=[]
      ERP.getRequest({
        url:"admin/ReceivablesSplitMerge/getIds",
        data:{
          project_id:that.project_id,
          where:JSON.stringify(where),
          page: this.pageData.page,
          page_size: this.pageData.pageSize
        }
      },res=>{
        if(res.code) {
          that.form.order_ids=res.data
          if(that.form.order_ids.length){
            // this.form = this.getFormData({})
            that.progressObj={
              percentage:0,
              status:"primary",//success
              msg:""
            };
            that.dialogVisible = true
          }else {
            that.$message.error("当前无拆分费项");
          }
        }

      })
    },
    submitForm(formName) {
      var that=this;
      that.formLoading = true
      let data = Object.assign({}, this.form)
      data.project_id=that.project_id;
      data.order_ids&&(data.order_ids=data.order_ids.join(','));
      data.start_end_time&&(data.start_end_time=data.start_end_time.join(','));
      that.progressObj.percentage=20;
      that.progressObj.msg="数据已经处理提交中……";
      ERP.postRequest({url:"admin/ReceivablesSplitMerge/receivablesSplit", data:data},res => {
        if(res.code) {
          that.progressObj.percentage=100;
          that.progressObj.msg=res.msg||"数据处理成功";
          that.progressObj.status="success";
          that.getList()
        }else {
          that.progressObj.percentage=100;
          that.progressObj.msg=res.msg||"数据处理异常";
          that.progressObj.status="exception";
        }
        that.formLoading = false
      })
    },
    handleSelectionChange(val) {
      let old_list=this.multipleSelection;
      let startDate_arr=val.map(ret=>{ return ret.startDate })
      let endDate_arr=val.map(ret=>{ return ret.endDate })
      let h_name_date_arr=val.map(ret=>{ return ret.h_name_date })

      try {
        if(array_unique(startDate_arr).length>1||array_unique(endDate_arr).length>1){
          throw new Error('时间不一致')
        }

        this.multipleSelection = val;
      }catch (e) {
        let old_list_ids=old_list.map(ret=>{ return ret.id })
        let new_list_ids=val.map(ret=>{ return ret.id })

        old_list_ids=array_unique(old_list_ids);
        new_list_ids=array_unique(new_list_ids);

        let list_diff=array_diff(old_list_ids,new_list_ids);

        if(list_diff.length){
          this.$refs.Table.toggleRowSelection(val.find(ret=>{ return ret.id===list_diff[0] }));
        }
        this.$message.error(e)
      }
    },
    nodeClick(data){
      // this.$refs.OrderLog.nodeClick(data);
      this.$refs.OrderSplit.nodeClick(data);
      this.where.h_name_date=data.tree.map(ret => {
        return ret.name
      }).join('->');
      this.where.project_house_id = data.tree[0].pindex_id;
      this.project_id=data.tree[0].pindex_id;
      this.$forceUpdate()
    },
    getHouseChargeItemList(){//费项类型表
      if(this.where.project_house_id == ''){
        // this.$message.error("点击左边树选择房产");
        return false;
      }
      var that=this;
      let where={};
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200,
          project_house_id:this.where.project_house_id
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){//费项表
      if(this.where.project_house_id == ''){
        // this.$message.error("点击左边树选择房产");
        return false;
      }
      var that=this;
      let where={};
      this.where.project_house_id&&(where.pindex_id=this.where.project_house_id);
      this.where.xsc_ChargeItemID_id&&(where.chargeItem_name_id=this.where.xsc_ChargeItemID_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200,
          project_house_id:this.where.project_house_id
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}

function array_unique(arr) {
  let set=new Set();
  arr.map(ret=>{set.add(ret)});
  return Array.from(set);
}

function array_diff(arr1, arr2) {
  return arr1.concat(arr2).filter(function(arg){
    return !(arr1.indexOf(arg) >= 0 && arr2.indexOf(arg) >= 0);
  });
}
</script>
<style lang="scss" scoped>

.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  // margin-top: 2%;
  // margin-right: 3%;
  text-align: right;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}


.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/ReceivablesSplit.vue